var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "project-documents-documents" } },
    [
      !_vm.canProjectAccess
        ? _c("p", [
            _vm._v("\n    " + _vm._s(_vm.$t("noTabPermission")) + "\n  "),
          ])
        : [
            _c(
              "div",
              { staticClass: "project-documents-doc-header clearfix" },
              [
                _c(
                  "div",
                  {
                    staticClass: "project-documents-doc-header-font float-left",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("project.docs.header")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isProjectRepresentative || !_vm.isContractor
                  ? _c("AddDocType")
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: {
                      "btn--darkblue": _vm.isExpand,
                      "btn--orange": !_vm.isExpand,
                      btn: true,
                      "float-right": true,
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function () {
                        return _vm.toggleExpandAll()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.isExpand
                            ? _vm.$t("collapseAll")
                            : _vm.$t("expandAll")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "project-documents-doc-type" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("project.docs.projectFolder")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "project-documents-accordion-container" },
              [
                _c("DocAccordion", {
                  ref: "docAccordion",
                  attrs: { isContractor: _vm.isContractor },
                  on: {
                    docAccordionExpand: function (isExpand) {
                      return _vm.setIsExpand(isExpand)
                    },
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }